import React from "react";
import Logo from "../../../../Logo";
import { getSelectedLogoUrl } from "../../../../Logo";
import DOMPurify from "dompurify";

const IntroPreview = ({ formData, dynamicStyles, client }) => {
  const fallbackTitle =
    formData?.type === "memory" ? "Memory Game" : "Connections Game";
  const selectedLogoUrl = getSelectedLogoUrl(client, formData?.reveal);
  const hideDefault =
    client === "delta" && !!formData?.reveal?.logo?.folder ? true : false;

  return (
    <div className="intro-preview" style={dynamicStyles}>
      <div className="preview-logo">
        <Logo
          client={client}
          logoUrl={selectedLogoUrl}
          hideDefault={hideDefault}
        />
      </div>

      {formData.bannerImage ? (
        <div className="banner-image">
          <img src={formData.bannerImage} alt="Banner" />
        </div>
      ) : null}
      <div className="game-title">
        <h2
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(formData.name || fallbackTitle),
          }}
        />
      </div>

      {formData.introMessage.instructions && (
        <div className="welcome-message">
          <p>{formData.introMessage.instructions}</p>
        </div>
      )}

      {formData.introMessage.howTo && (
        <div
          className="instructions"
          dangerouslySetInnerHTML={{ __html: formData.introMessage.howTo }}
        />
      )}

      <button className="start-button">START</button>

      {formData.termsType !== "none" && formData.terms?.trim() ? (
        <div className="terms-link">Terms and Conditions</div>
      ) : null}
    </div>
  );
};

export default IntroPreview;
